import Vue from 'vue'

export default {
    storeExcuses(state, excusesPagination) {
        state.excuse_pages = excusesPagination.last_page
        excusesPagination.data.forEach((excuse) => {
            Vue.set(excuse, 'page', excusesPagination.current_page)
            this.commit('storeExcuse', excuse)
        })
    },
    storeExcuse(state, excuse) {
        const excuseIndex = state.excuses.findIndex(item => item.id === excuse.id)
        if (excuseIndex === -1) {
            state.excuses.push(excuse)
        } else {
            if (state.excuses[excuseIndex].page) {
                Vue.set(excuse, 'page', state.excuses[excuseIndex].page)
            }
            Vue.set(state.excuses, excuseIndex, excuse)
        }
    },
    storeExcusesForToday(state, excuses) {
        state.excuses_today = excuses
    },
    clearExcuses(state) {
        Vue.set(state, 'excuses', [])
    },
    setExcusesTodayStatus(state, loaded) {
        Vue.set(state, 'excuses_today_status', loaded)
    }
}
